import { NgModule, NgZone } from "@angular/core";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { UniversalExpressModule } from "@obg/ngx.universal-express";
import { UniversalRouterModule } from "@obg/ngx.universal-router";

import { AppComponent } from "./app.component";
import { AppModule } from "./app.module";

@NgModule({
	imports: [AppModule, UniversalExpressModule.forRoot(), UniversalRouterModule.forRoot(), NoopAnimationsModule],
	bootstrap: [AppComponent],
})
export class AppDOMServerModule {
	constructor(ngZone: NgZone) {
		// eslint-disable-next-line rxjs/no-ignored-subscription
		ngZone.onStable.subscribe(() => window.dispatchEvent(new CustomEvent("ng-app-stable")));
	}
}
